const PRECISION_MULTIPLIER = 1e10;
const EPSILON = 1e-11;

export function normalizeValue(value: unknown): unknown {
  if (typeof value === 'string') {
    const trimmed = value.trim();
    const num = Number(trimmed.replace(/\s/g, ''));
    if (!Number.isNaN(num) && trimmed !== '') {
      return num;
    }
    return trimmed;
  }
  if (typeof value === 'number') {
    return Math.round(value * PRECISION_MULTIPLIER) / PRECISION_MULTIPLIER;
  }
  return value;
}

export function valuesEqual(a: unknown, b: unknown): boolean {
  const na = normalizeValue(a);
  const nb = normalizeValue(b);
  if (na === '' && (nb === null || nb === undefined)) return true;
  if (nb === '' && (na === null || na === undefined)) return true;
  if (typeof na === 'number' && typeof nb === 'number') {
    return Math.abs(na - nb) < EPSILON;
  }
  
  return na === nb;
}

export function createCellKey(rowIdentifier: string | number, field: string | number): string {
  return `${rowIdentifier}:${field}`;
}

export function parseCellKey(key: string): { row: string; field: string } {
  const [row, ...fieldParts] = key.split(':');
  return { row, field: fieldParts.join(':') };
}

